(function($) {
    /**
     * Class that abstracts reading of device orientation relative to earth
     * Detects if Sensors API is present and obtains heading angle from the readings
     * Otherwise, if non-standard DeviceOrientationAbsolute is present, it tries to obtain it from those readings
     * 
     * Note: DeviceOrientationAbsolute is poorly implemented in google chrome for mobile and has rotation, and precision issues
     */
    $.Compass = function () {
        // 1. set component name
        this._component_name = "compass"; 

        // 2. set events
        this._events = {
            ready: "ready", 
            heading: "heading",
            started: "started",
            stopped: "stopped"
        };

        if (typeof(window) === "undefined") {
            return;
        }
 
        this._degtorad = Math.PI / 180;
        this._radtodeg = 180 / Math.PI;
        
        // device orientation methods flags
        this._has_sensors_api = false;
        this._has_DeviceOrientationAbsolute = false;
        this._has_device_orientation = false;
        this._detect_method(); // initializes above flags

        // flag to decide whether orientation will be captured or not
        this._orientation_enabled = false;

        // bind events to "this" object
        this._sensor_api_reading = this._sensor_api_reading.bind(this);
        this._orientation_listener = this._orientation_listener.bind(this);
        // events for interaction with tracker
        // to save battery, compass should be active only when the GPS tracking is visible
        this._location_icon_added = this._location_icon_added.bind(this); 
        this._location_icon_removed = this._location_icon_removed.bind(this); 

        $.Component.call(this, $.Compass);
    };

    $.Component.create($.Compass, {
        _init_: function(options) { 
            this._options = options || {};
        
            this._frequency = options.frequency || 60;
            
            // use Sensors API if found
            if (this._has_sensors_api) {  
                this._sensor = new AbsoluteOrientationSensor({frequency: this._frequency, referenceFrame: "device"}); 
                this._sensor.addEventListener("reading", this._sensor_api_reading);  
            }
            // else try to use non-standard DeviceOrientationAbsolute event
            else if (this._has_DeviceOrientationAbsolute) {  
                this._rotation_filter = null;
                // fusion accuracy on this API is very poor, we need to use a Kalman filter
                if (typeof(KalmanFilter) !== "undefined") {
                    this._rotation_filter = new KalmanFilter();
                }
                
                window.addEventListener("deviceorientationabsolute", this._orientation_listener);  
            }    

            $.on("tracker_location_icon_added", this._location_icon_added);
            $.on("tracker_location_icon_removed", this._location_icon_removed);
    
            // 4. initialize subcomponents (if any)
            // this has to be done after this._options has been set
            $.Component.call(this, $.Compass);  
        },

        _location_icon_added: function() { 
            this.start(); 
        },

        _location_icon_removed: function() {  
            this.stop();
        },

        _detect_method: function() { 
            this._has_sensors_api = typeof(AbsoluteOrientationSensor) === "function";   
            this._has_DeviceOrientationAbsolute = "ondeviceorientationabsolute" in window;  

            this._has_device_orientation = this._has_DeviceOrientationAbsolute || this._has_sensors_api;
        },

        _sensor_api_reading: function(event) { 
            // heading formula from https://mobiforge.com/design-development/the-generic-sensor-api
            var q = this._sensor.quaternion; 
            var heading = Math.atan2(2*(q[0]*q[1] + q[2]*q[3]), 1 - 2*(q[1]*q[1] + q[2]*q[2])) * this._radtodeg;
            this._emit(this._events.heading, heading);
        },

        _orientation_listener: function(event) {  
            if (event.absolute) {
                // can get heading only if orientation is absolute 
                var heading = this._get_heading(event);
                if (this._rotation_filter) {
                    heading = this._rotation_filter.filter(heading);
                }
                this._emit(this._events.heading, heading); 
            }
        },
        _get_heading: function(event) { 
            // safari iOS provides heading in this non-standard way
            if (typeof(event.webkitCompassHeading) !== "undefined") {
                return event.webkitCompassHeading;
            }
            // otherwise estimate it from the angles
            else {
                // https://w3c.github.io/deviceorientation/spec-source-orientation.html#worked-example
                var _x = event.beta  ? event.beta  * this._degtorad : 0; // beta value
                var _y = event.gamma ? event.gamma * this._degtorad : 0; // gamma value
                var _z = event.alpha ? event.alpha * this._degtorad : 0; // alpha value
                
                // var cX = Math.cos( _x );
                var cY = Math.cos( _y );
                var cZ = Math.cos( _z );
                var sX = Math.sin( _x );
                var sY = Math.sin( _y );
                var sZ = Math.sin( _z );
                
                // Calculate Vx and Vy components
                var Vx = - cZ * sY - sZ * sX * cY;
                var Vy = - sZ * sY + cZ * sX * cY;
                
                // Calculate compass heading
                var compassHeading = Math.atan( Vx / Vy );
                
                // Convert compass heading to use whole unit circle
                if( Vy < 0 ) {
                    compassHeading += Math.PI;
                } else if( Vx < 0 ) {
                    compassHeading += 2 * Math.PI;
                }
                
                return 360 - compassHeading * this._radtodeg;// Compass Heading (in degrees)
            } 
        },

        start: function() {  
            if (this._has_sensors_api) {
                this._sensor.start();
            }
            else if (this._has_DeviceOrientationAbsolute) {
                window.addEventListener("deviceorientationabsolute", this._orientation_listener);
            }
            else {
                return;
            }
            this._emit(this._events.started, this);
        },

        stop: function() {  
            if (this._has_sensors_api) {
                this._sensor.stop();
            } 
            else if (this._has_DeviceOrientationAbsolute) {
                window.removeEventListener("deviceorientationabsolute", this._orientation_listener);
            }
            else {
                return;
            }

            this._emit(this._events.stopped, this);
        }, 
 
    }, $.OSD);
})(ABDOMap);